export class User{
    id: string;
    nome: string;
    email: string;
    telerone: string;
  } 

  export class ResponseUser{
    user: User;
    token: string    
  } 
  

  export interface jwtDecode{
    aud: string,
    exp: string ,
    iat: boolean,
    iss: any,
    nameid: any,  
    nbf: any
  } 